import { render, staticRenderFns } from "./SingleStepEvent.vue?vue&type=template&id=6b877539&scoped=true"
import script from "./SingleStepEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStepEvent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleStepEvent.vue?vue&type=style&index=0&id=6b877539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b877539",
  null
  
)

export default component.exports